/* PYNRS: Shop Women / Shop Men tabs on the Variant Carousel. Toggles the tab panels, moves the Shop all link and rewinds the shown carousel. */
(function () {
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.pynrs-carousel-tab');
    if (!tab) return;
    var scope = tab.closest('.shopify-section') || document;
    var name = tab.getAttribute('data-tab');
    scope.querySelectorAll('.pynrs-carousel-tab').forEach(function (t) {
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
    });
    scope.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
      var on = panel.getAttribute('data-tab-panel') === name;
      panel.hidden = !on;
      if (on) {
        var list = panel.querySelector('product-list');
        if (list) list.scrollTo({ left: 0, behavior: 'instant' });
      }
    });
    var link = scope.querySelector('[data-shop-all-link]');
    var href = tab.getAttribute('data-shop-all');
    if (link && href) link.setAttribute('href', href);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target && event.target.closest ? event.target.closest('[data-tab-panel]') : null;
    if (!panel || !panel.hidden) return;
    var scope = panel.closest('.shopify-section');
    var tab = scope && scope.querySelector('.pynrs-carousel-tab[data-tab="' + panel.getAttribute('data-tab-panel') + '"]');
    if (tab) tab.click();
  });
})();
